export const homeRoute: string = 'home';

export * from '../header/header.component'
export * from './homepage-shell/homepage-shell.component'
export * from './advantage-tile/index'
export * from '../outstanding-bobby-declarations/index'